import * as React from 'react';
import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={51} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <mask
      id="mask0_8457_514859"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="51"
      height="10"
    >
      <path
        d="M8.36451 0.833496H4.99967C3.99288 0.833496 3.06959 1.19029 2.34937 1.78525C1.42323 2.54913 0.833008 3.70585 0.833008 5.00016C0.833008 6.00696 1.1898 6.93025 1.78476 7.65047C1.95462 7.85638 2.14345 8.04522 2.34937 8.21507C3.06959 8.80909 3.99288 9.16683 4.99967 9.16683C6.29399 9.16683 7.45071 8.57661 8.21458 7.65047C8.8086 6.93025 9.16634 6.00696 9.16634 5.00016V1.63533C9.16634 1.19219 8.80765 0.833496 8.36356 0.833496H8.36451ZM7.57786 5.00016C7.57786 5.62644 7.35582 6.20149 6.98574 6.65032C6.51034 7.22726 5.79012 7.59448 4.98449 7.59448C4.35821 7.59448 3.78317 7.37244 3.33433 7.00237C3.20623 6.89704 3.08857 6.77842 2.98229 6.65032C2.61221 6.20149 2.39017 5.62739 2.39017 5.00016C2.39017 4.19454 2.7574 3.47432 3.33433 2.99891C3.78317 2.62884 4.35726 2.40679 4.98449 2.40679C6.4164 2.40679 7.57786 3.56826 7.57786 5.00016Z"
        fill="url(#paint0_linear_8457_514859)"
      />
      <path
        d="M11.0206 8V2.4H13.1486C13.6019 2.4 13.9779 2.47733 14.2766 2.632C14.5752 2.78667 14.7966 2.99733 14.9406 3.264C15.0899 3.52533 15.1646 3.824 15.1646 4.16C15.1646 4.46933 15.0926 4.75733 14.9486 5.024C14.8099 5.28533 14.5912 5.49867 14.2926 5.664C13.9939 5.82933 13.6126 5.912 13.1486 5.912H12.1406V8H11.0206ZM12.1406 5.008H13.0766C13.4126 5.008 13.6526 4.93067 13.7966 4.776C13.9459 4.62133 14.0206 4.416 14.0206 4.16C14.0206 3.89333 13.9459 3.68533 13.7966 3.536C13.6526 3.38667 13.4126 3.312 13.0766 3.312H12.1406V5.008ZM15.9659 8V2.4H17.0859V7.128H19.5339V8H15.9659ZM20.0901 8L22.1301 2.4H23.4021L25.4421 8H24.2581L22.7621 3.672L21.2581 8H20.0901ZM20.9861 6.744L21.2821 5.872H24.1621L24.4501 6.744H20.9861ZM26.8793 8V3.304H25.2473V2.4H29.6233V3.304H27.9913V8H26.8793ZM30.3799 8V2.4H31.4999V8H30.3799ZM32.5909 8V2.4H33.7109L36.2469 6.2V2.4H37.3669V8H36.2469L33.7109 4.208V8H32.5909ZM40.6421 8.096C40.2261 8.096 39.8501 8.01333 39.5141 7.848C39.1781 7.68267 38.9087 7.43467 38.7061 7.104C38.5087 6.768 38.4101 6.344 38.4101 5.832V2.4H39.5301V5.84C39.5301 6.112 39.5754 6.33867 39.6661 6.52C39.7567 6.70133 39.8847 6.84 40.0501 6.936C40.2207 7.02667 40.4261 7.072 40.6661 7.072C40.9061 7.072 41.1087 7.02667 41.2741 6.936C41.4447 6.84 41.5754 6.70133 41.6661 6.52C41.7567 6.33867 41.8021 6.112 41.8021 5.84V2.4H42.9221V5.832C42.9221 6.344 42.8181 6.768 42.6101 7.104C42.4074 7.43467 42.1327 7.68267 41.7861 7.848C41.4394 8.01333 41.0581 8.096 40.6421 8.096ZM43.9503 8V2.4H45.2943L46.9823 5.848L48.6463 2.4H49.9823V8H48.8623V4.296L47.4143 7.216H46.5263L45.0703 4.296V8H43.9503Z"
        fill="url(#paint1_linear_8457_514859)"
      />
    </mask>
    <g mask="url(#mask0_8457_514859)">
      <rect y="-5" width="51" height="19" fill="white" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8457_514859"
        x1="0.854362"
        y1="0.899414"
        x2="9.90526"
        y2="1.76964"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22CFAB" />
        <stop offset="0.933931" stopColor="#0057A7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8457_514859"
        x1="10.1051"
        y1="0.0791015"
        x2="49.0025"
        y2="15.4127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22CFAB" />
        <stop offset="0.933931" stopColor="#0057A7" />
      </linearGradient>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const IconPlatinumWhite = memo(ForwardRef);
export default IconPlatinumWhite;
